<template>
    <div class="window">
        <el-dialog title="产品详情" :visible.sync="showBlock" width="500px" :before-close="closedBtn">
            <!--顶部图片-->
            <div class="common-items-center imgBlock">
                <div class="img" v-for="(item,index) in imgList" :key="index">
                    <el-image  style="width:100%" :src="item" :preview-src-list="[item]"/>
                </div>
            </div> 
            <div class="line block" v-for="(item,index) in listData" :key="index">
                <span v-if="!!item.val" class="title">{{item.title}}：</span>
                <span v-if="!!item.val" class="nameT">{{item.val}}</span>
                <CopyBtn v-if="!!item.val" :text="item.val"></CopyBtn>
            </div>
            <div class="footer">
                <el-button type="primary" @click="closedBtn">返回</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { postFun,httpImg } from '@/utils/httpFun'
import {url,api} from '@/utils/config'

export default {
   data:()=>({
      showBlock:false,
      imgList:[],
      listData:[], 
   }),
   methods:{
      openBtn(parms){
        this.listData = parms.list
        this.showBlock = true 
        if(!parms.imgList){
            this.imgList = [require('@/assets/custom-image/404.gif')]
            return
        }
        httpImg(parms.imgList,res=>{
           this.imgList = res
        })
      },
      //关闭
      closedBtn(){
         this.showBlock = false 
      }
   }
}
</script>
<style scoped lang="scss">
   .window{
        ::v-deep .el-dialog__body{
           padding-top: 0px;
        }
        .footer{
           display: flex;
           justify-content: flex-end;
           padding-top: 40px;
        }
        .imgBlock{
            margin-bottom: 15px;
            display: flex;
            flex-wrap: wrap;
        }
        .img{
           width: 82px;
           height: 82px;
           margin-right: 10px;
           border-radius:4px; 
           margin-bottom: 10px;
           overflow: hidden; 
        }
        .line{
            margin-top:15px;
        }
        .title{
            width: 100px;
            text-align: right;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #56585C;
           
            display: block;
        }
        .block{
            width: 100%;
            display: flex;
            align-items: center;
        }
        .nameT{
            font-size: 14px;
            color: black;
            width: 300px;
           
            display: block;
            margin-left: 24px;
        }
       
       

   }
</style>